import {Component, OnInit, ViewChild} from '@angular/core';
import {PartenaireService} from '../../shared/services/partenaire.service';
import {PartnerDtoModel} from '../../shared/models/partner.dto.model';
import {FileService} from '../../shared/services/file.service';
import {LoaderService} from '../../shared/services/loader.service';
import {LocalizationService} from '../../shared/services/localization.service';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {FileUpload} from 'primeng/fileupload';
import {PaginationArgs} from '../../shared/models/pagination.args';
import {ConfirmationService, LazyLoadEvent, MessageService} from 'primeng/api';
import {CategoryDtoModel} from '../../shared/models/category.dto.model';
import {CategoryService} from '../../shared/services/category.service';
import {ErrorStateMatcher} from '@angular/material/core';
import {CountryDtoModel} from '../../shared/models/country.dto.model';
import {CountryService} from '../../shared/services/country.service';
import {Router} from '@angular/router';

@Component({
    selector: 'njoy-gestion-partenaire',
    templateUrl: './gestion-partenaire.component.html',
    styleUrls: ['./gestion-partenaire.component.scss']
})
export class GestionPartenaireComponent implements OnInit {

    public partners: PartnerDtoModel[] = [];
    public categories;
    public allCategories;

    public selectedPartner: PartnerDtoModel;

    public modalTitle = '';

    public addNewPartnerDialog = false;

    public partnerForm;
    public uploadedFile;
    public displayImage = false;
    @ViewChild('fileUpload')
    public fileUploader: FileUpload;

    public paginationArgs: PaginationArgs = {pageNumber: 0, pageSize: 10};
    public totalRecords = 0;
    public first = 0;
    public row = 0;

    public noFileUploaded = false;
    public noCategorySelected = false;
    public matcher = new ErrorStateMatcher();
    public partnerHeartStroke = false;
    public partnerPopular = false;
    public countries = [];
    public addressNotFound = false;
    public selectedCategory;
    public nameToSearch = '';
    public remainingText = 2000;


    constructor(private partenaireService: PartenaireService,
                private router: Router,
                private countryService: CountryService,
                public localizationService: LocalizationService,
                private formBuilder: UntypedFormBuilder,
                private fileService: FileService,
                private categoryService: CategoryService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService,
                private loaderService: LoaderService) {
    }

    ngOnInit(): void {
        this.findAllCategories();
    }

    public setRemainingCharsValue(): void {
        this.remainingText = 2000 - this.getControl.description.value.length;
    }

    private findAllCategories(): void {
        this.loaderService.startLoading();
        this.categoryService.findAllCategories().subscribe((data: CategoryDtoModel[]) => {
                this.setDropDownCategories(data);
                this.findAllPartenaires();
                this.loaderService.stopLoading();
            }, ((error: any) => {
                this.loaderService.stopLoading();
                console.log(error);
            })
        );
    }

    private setDropDownCategories(data: CategoryDtoModel[]): void {
        this.categories = [];
        data.forEach((item: CategoryDtoModel) => {
            this.categories.push({
                label: item.label,
                value: item.uuid
            });
            this.allCategories = [...this.categories];
        });
    }

    public addNew(): void {
        this.router.navigate(['/partners', 0]);
    }

    private initEmptyForm(partner?: PartnerDtoModel) {
        this.selectedPartner = partner;
        this.partnerForm = this.formBuilder.group({
            name: [partner.name, [
                Validators.required
            ]],
            streetAddress: [partner.address.streetAddress, [
                Validators.required
            ]],
            city: [partner.address.city, [
                Validators.required
            ]],
            zipCode: [partner.address.zipCode, [
                Validators.required
            ]],
            description: [partner.description, [
                Validators.required,
                Validators.maxLength(2000)
            ]]
        });
        this.setRemainingCharsValue();
    }

    get getControl() {
        return this.partnerForm.controls;
    }


    private findAllPartenaires(skipCountry?: boolean): void {
        this.loaderService.startLoading();
        this.partenaireService.findAllPartenaires(this.nameToSearch.trim(), this.paginationArgs).subscribe((data: any) => {
                this.partners = data.content;
                this.partners.forEach((partner: PartnerDtoModel) => {
                    partner.categoryName = partner.mainCategory.label;
                });
                this.totalRecords = data.totalElements;
                this.row = this.paginationArgs.pageSize;
                if (!skipCountry) {
                    this.getListCountries();
                } else {
                    this.loaderService.stopLoading();
                }
            }, ((error: any) => {
                this.loaderService.stopLoading();
                console.log(error);
            })
        );
    }

    public onLazyLoad(event: LazyLoadEvent) {
        this.paginationArgs = {pageNumber: event.first / event.rows, pageSize: event.rows};
        this.findAllPartenaires(true);
    }

    public selectPartner(partner: any) {
        this.modalTitle = this.localizationService.translate('PARTNER.UPDATE_MODAL_TITLE');
        this.displayImage = true;
        this.addNewPartnerDialog = true;
        this.partnerPopular = partner.popular;
        this.partnerHeartStroke = partner.heartStroke;
        this.selectedCategory = this.categories.find(value => value.label === partner.categoryName);
        this.categories = [...this.allCategories];
        partner.secondaryCategories.forEach((category: CategoryDtoModel) => {
            const index = this.categories.findIndex((val: any) => val.value === category.uuid);
            if (index !== -1) {
                this.categories.splice(1, index);
            }
        });
        this.initEmptyForm(partner);
    }


    public addOrUpdatePartner(): any {
        this.displayRequiredMessage();
        if (this.partnerForm.status === 'VALID' && !this.noCategorySelected) {
            this.addressNotFound = false;
            if (!this.displayImage) {
                this.uploadFile()
            } else {
                this.updatePartner();
            }
        }
    }

    private uploadFile() {
        this.loaderService.startLoading();
        this.fileService.uploadPartnerFile(this.uploadedFile).subscribe(
            (path: string) => {
                this.updatePartner(path);
            }, (err: any) => {
                this.loaderService.stopLoading();
                console.log(err)
            }
        );
    }

    private updatePartner(path?: string) {
        this.setValues(this.selectedPartner);
        if (this.selectedCategory.label) {
            this.selectedPartner.mainCategorieUuid = this.selectedCategory.value
        } else {
            this.selectedPartner.mainCategorieUuid = this.selectedCategory
        }
        if (path) {
            this.selectedPartner.imagePath = path;
        }
        this.partenaireService.updatePartner(this.selectedPartner).subscribe(() => {
            this.displaySuccessMessage('CLIENT.SUCCESS_SUMMARY', 'PARTNER.UPDATE_SUCCESS_DETAIL');
        }, (error => {
            this.loaderService.stopLoading();
            console.log(error);
            if (error.error.code === 4031) {
                this.addressNotFound = true;
            }
        }));
    }

    private setValues(partner: PartnerDtoModel) {
        partner.name = this.getControl.name.value;
        partner.address.streetAddress = this.getControl.streetAddress.value;
        partner.address.city = this.getControl.city.value;
        partner.address.zipCode = this.getControl.zipCode.value;
        partner.popular = this.partnerPopular;
        partner.heartStroke = this.partnerHeartStroke;
        partner.description = this.getControl.description.value;
        partner.secondaryCategoriesUuids = this.selectedPartner.secondaryCategories.map(value => value.uuid);
    }

    private displayRequiredMessage(): void {
        this.noFileUploaded = false;
        this.noCategorySelected = false;
        this.partnerForm.touched = true;
        const keys = Object.keys(this.partnerForm.controls);
        keys.forEach((element: any) => {
            this.partnerForm.controls[element].touched = true;
        });
        if (!this.uploadedFile) {
            this.noFileUploaded = true;
        }
    }

    public onUpload(event) {
        this.noFileUploaded = false;
        this.uploadedFile = event.files[0];
    }

    public clearFile() {
        this.uploadedFile = undefined;
    }

    public changeSelectedCategory(categoryEvent: any) {
        this.selectedCategory = categoryEvent.value;
    }

    public changeImageValue(): void {
        this.displayImage = false;
        setTimeout(() => this.fileUploader.advancedFileInput.nativeElement.click(), 100);
    }

    public confirmDeletePartner(partner: any) {
        this.confirmationService.confirm({
            message: this.localizationService.translate('PARTNER.DELETE_CONFIRMATION_MESSAGE') + partner.name,
            accept: () => {
                this.deletePartner(partner.uuid);
            }
        });
    }

    private deletePartner(uuid: string): void {
        this.partenaireService.deletePartner(uuid).subscribe(
            () => {
                this.loaderService.stopLoading();
                this.displaySuccessMessage('CLIENT.SUCCESS_SUMMARY', 'PARTNER.DELETE_SUCCESS_DETAIL');
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
            }
        );
    }

    private displaySuccessMessage(summary: string, detail: string): void {
        this.messageService.add({
            severity: 'success',
            summary: this.localizationService.translate(summary),
            detail: this.localizationService.translate(detail)
        });
        this.addNewPartnerDialog = false;
        this.findAllPartenaires(true);
    }

    private getListCountries(): void {
        this.countryService.findAllCountries().subscribe((data: CountryDtoModel[]) => {
            this.loaderService.stopLoading();
            this.countries = data;
        }, (err: any) => {
            this.loaderService.stopLoading();
            console.log(err);
        });
    }

    public searchPartner(): void {
        this.findAllPartenaires(true);
    }
}
